module.exports = __webpack_public_path__ + "img/jianbian_icon.9f8dacdc.png";